import { PageLayout, PageNames } from '@diana/core';
import { Box, useMediaQuery, useTheme } from '@mui/material';
import { isDesktop } from 'react-device-detect';
import { DndLayoutComponentsProvider } from '../../../../providers/DndLayoutComponents2';
import { useConfigureEditorDrawer } from '../../Drawers/ConfigureEditorDrawer/useConfigureEditorDrawer';
import { useToolsDrawer } from '../../Drawers/ToolsDrawer/useToolsDrawer';
import { BuilderTypeEnum } from '../../Store/FlowBuilder2PageStore.types';
import { useFlowBuilder2PageStore } from '../../Store/useFlowBuilder2PageStore';
import { useBuilderContentHeight } from '../../Support/useBuilderContentHeight';
import { AeViewContent } from '../AeView/AeViewContent';
import { DesktopOnlyErrorView } from '../DesktopOnlyErrorView/DesktopOnlyErrorView';
import { BuilderViewNavbar } from './BuilderViewNavbar';
import { Content } from './Content';
import { DndSentinel } from './DndSentinel/DndSentinel';

export const BuilderView = () => {
  const { palette, breakpoints } = useTheme();
  const isSmallDevice = useMediaQuery(breakpoints.down('lg'));

  const isAdvancedEditorOpened = useFlowBuilder2PageStore(
    (store) => store.builderType === BuilderTypeEnum.AdvancedEditor,
  );

  const isPageBlocked = isSmallDevice || !isDesktop;

  const leftDrawerProps = useToolsDrawer();
  const rightDrawerProps = useConfigureEditorDrawer();
  const height = useBuilderContentHeight();

  return (
    <DndLayoutComponentsProvider>
      <DndSentinel />
      <BuilderViewNavbar />
      {isPageBlocked && <DesktopOnlyErrorView />}
      <Box display={isPageBlocked ? 'none' : 'initial'}>
        <PageLayout
          name={PageNames.FLOW_BUILDER}
          leftDrawer={leftDrawerProps}
          rightDrawer={rightDrawerProps}
          backgroundColor={palette.background.paper}
          disableMainPadding
        >
          <Box p={2} sx={{ minHeight: height }}>
            {isAdvancedEditorOpened ? <AeViewContent /> : <Content />}
          </Box>
        </PageLayout>
      </Box>
    </DndLayoutComponentsProvider>
  );
};
